import React, { useState, useEffect, useMemo } from "react"
import Pagination from '../../pages/paginations'
import { Add } from './Add'
import { Edit } from './Edit'
import axiosJWT from '../../JwtToken'

function View() {
    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(10)
    const [data, setData] = useState([])
    const [add, setAdd] = useState(false)
    const [rowID, setRowID] = useState(null)
    const [edit, setEdit] = useState(false)
    const [deleteID, setDeleteID] = useState(null)

    useEffect(() => {
        getData('')
    }, [])

    const getData = async (key) => {
        try {
            const response = await axiosJWT.post("/api/pks-mandiri", { key: key })
            setData(response.data)
            setCurrentPage(1)
        } catch (err) {
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Data tidak terkirim, mohon coba lagi!')
            setTimeout(() => {
                setPesan(false)
                setMsg("")
            }, 2000)
        }
    }

    // 🔥 Fungsi hapus disesuaikan dengan klan PKS Mandiri
    const prosesHapus = async () => {
        if (!deleteID) return

        try {
            const hapus = await axiosJWT.delete(`/api/pks-mandiri/delete/${deleteID}`)

            // Tutup modal konfirmasi dulu biar gak numpuk bray
            setDeleteID(null)

            // Munculin modal pesan sukses
            getPesan()
            setMsg(hapus.data.msg)

            setTimeout(() => getData(''), 1000)
            setTimeout(() => {
                setPesan(false)
                setMsg("")
            }, 2000)
        } catch (err) {
            setDeleteID(null)
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Gagal menghapus data, silakan coba lagi!')
            setTimeout(() => {
                setPesan(false)
                setMsg("")
            }, 2000)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !data ? [] : data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage, PageSize])

    const getPesan = () => {
        setPesan((prevState) => !prevState)
    }

    const openAdd = () => {
        setAdd(true)
    }

    const closeAdd = () => {
        setAdd(false)
    }

    const openEdit = (id) => {
        setRowID(id)
        setEdit(true)
    }

    const closeEdit = () => {
        setRowID(null)
        setEdit(false)
    }

    const triggerHapus = (id) => {
        setDeleteID(id)
    }

    return (<>
        <div className="container">
            <div className="card animated fadeInUp animation-delay-7 br-2 mb-6">
                <div className="card-body p-5">
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-2 col-xs-4">
                                <button onClick={openAdd} className="btn btn-raised btn-primary br-2 no-m">
                                    <i className="fa fa-plus"></i> Tambah
                                </button>
                            </div>
                            <div className="col-md-10 col-xs-8">
                                <input type="text" className="form-control" placeholder="Masukkan Kata Kunci Pencarian..." onChange={(e) => getData(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-nomargin dataTable table-bordered data">
                            <thead>
                                <tr className="purple">
                                    <th>No</th>
                                    <th>No. PKS</th>
                                    <th>Tgl. PKS</th>
                                    <th>Vendor / Mitra</th>
                                    <th>Judul Pengadaan / Kegiatan</th>
                                    <th>Nilai Kontrak</th>
                                    <th>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">Data Pencatatan Kemitraan Mandiri Kosong</td>
                                    </tr>
                                ) : (
                                    tableData.map((row, i) => (
                                        <tr key={row._id}>
                                            <td width={"5%"}>{(currentPage - 1) * PageSize + (i + 1)}</td>
                                            <td width={"15%"}>{row.noPksDpmptsp}</td>
                                            <td width={"12%"} className="text-left">
                                                {row.tanggalPksDibuat
                                                    ? new Intl.DateTimeFormat('id-ID', { dateStyle: 'long' }).format(new Date(row.tanggalPksDibuat))
                                                    : '-'
                                                }
                                            </td>
                                            <td width={"20%"} className="text-left">{row.namaVendor}</td>
                                            <td width={"33%"} className="text-left">{row.judulPengadaan}</td>
                                            <td width={"20%"}>
                                                {row.nilaiTransaksi
                                                    ? new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(row.nilaiTransaksi)
                                                    : 'Rp 0'
                                                }
                                            </td>
                                            <td width={"10%"} className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                <button onClick={() => openEdit(row._id)} className="btn btn-raised btn-success br-2 no-m" style={{ marginRight: '5px' }}>
                                                    <i className="fa fa-pencil no-m"></i> Edit
                                                </button>
                                                <button onClick={() => triggerHapus(row._id)} className="btn btn-raised btn-danger br-2 no-m">
                                                    <i className="fa fa-remove no-m"></i> Hapus
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-2 col-xs-6">
                                Ditemukan <b>{data.length}</b> Data
                            </div>
                            <div className="col-md-10 col-xs-6">
                                <Pagination className="pagination-bar text-right" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* MODAL TAMBAH */}
        {add && (
            <div className="modal-open">
                <div style={{ display: 'block' }} className="modal modal-primary show" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center">Tambah Pencatatan Kemitraan Mandiri</h4>
                            </div>
                            <div className="modal-body">
                                <Add getData={getData} closeAdd={closeAdd} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}

        {/* 🔥 MODAL EDIT (Kondisional render terkunci aman, passing rowid singkron!) */}
        {edit && (
            <div className="modal-open">
                <div style={{ display: 'block' }} className="modal modal-primary show" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center">Edit Pencatatan Kemitraan Mandiri</h4>
                            </div>
                            <div className="modal-body">
                                <Edit getData={getData} rowid={rowID} closeEdit={closeEdit} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}

        {deleteID && (
            <div className="modal-open">
                <div style={{ display: 'block' }} className="modal modal-danger show" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog center">
                        <div className="modal-content modal-sm">
                            <div className="modal-header header-modal-danger p-1" style={{ backgroundColor: '#e51c23' }}>
                                <h4 className="modal-title text-center no-p font-bold" style={{ color: '#fff' }}>KONFIRMASI</h4>
                            </div>
                            <div className="modal-body text-center" style={{ padding: '20px 10px' }}>
                                <h4 className="font-bold" style={{ fontSize: '14px', margin: 0 }}>
                                    Apakah Anda yakin ingin menghapus data pencatatan kemitraan ini?
                                </h4>
                                <p className="text-danger" style={{ fontSize: '11px', marginTop: '5px', marginBottom: 0 }}>
                                    *Berkas fisik PDF di server juga akan dihapus permanen.
                                </p>
                            </div>
                            <div className="modal-footer text-center" style={{ padding: '10px', display: 'flex', justifyContent: 'center', gap: '10px', borderTop: '1px solid #eee' }}>
                                <button onClick={prosesHapus} type="button" className="btn btn-raised btn-danger br-2" style={{ margin: 0, padding: '6px 15px' }}>
                                    <i className="fa fa-check"></i> Ya, Hapus
                                </button>
                                <button onClick={() => setDeleteID(null)} type="button" className="btn btn-raised btn-default br-2" style={{ margin: 0, padding: '6px 15px', backgroundColor: '#e0e0e0' }}>
                                    Batal
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}

        {/* MODAL PESAN NOTIFIKASI */}
        {pesan && (
            <div className="modal-open">
                <div style={{ display: 'block' }} className="modal modal-primary show" id="myData" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog center">
                        <div className="modal-content modal-sm">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center no-p font-bold">PESAN</h4>
                            </div>
                            <div className="modal-body text-center">
                                <h4 className="font-bold">{msg.toUpperCase()}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}
    </>)
}

export default View